<template>
  <div>
    <h2 class="component-title">Način plaćanja</h2>
    <p class="about-next-step">Plaćanje ćeš završiti na sljedećem koraku</p>
    <div class="payment-methods">
      <div class="payment-method" @click="handlePaymentMethodClick(PaymentMethod.CreditCard)">
        <div class="payment-description">
          <div class="check-box">
            <span class="material-icons">
              {{
                buyer.paymentMethod === PaymentMethod.CreditCard
                  ? 'check_circle'
                  : 'radio_button_unchecked'
              }}
            </span>
          </div>
          <div class="payment-text">
            <h3 class="payment-type">{{ $t('cardPayment') }}</h3>
            <p class="payment-about">{{ $t('onlinePaymentWspay') }}</p>
          </div>
        </div>
        <div class="payment-logo">
          <img src="/assets/all-cards.svg" alt="Bank-cards" />
        </div>
      </div>
      <div class="payment-method" @click="handlePaymentMethodClick(PaymentMethod.KeksPay)">
        <div class="payment-description">
          <div class="check-box">
            <span class="material-icons">
              {{
                buyer.paymentMethod === PaymentMethod.KeksPay
                  ? 'check_circle'
                  : 'radio_button_unchecked'
              }}
            </span>
          </div>
          <div class="payment-text">
            <h3 class="payment-type">KEKS Pay</h3>
            <p class="payment-about">
              {{ $t('keksPayDesc') }}
            </p>
          </div>
        </div>
        <div class="payment-logo">
          <img src="/assets/Keks_pay.svg" alt="Keks pay" />
        </div>
      </div>
      <div class="payment-method" @click="handlePaymentMethodClick(PaymentMethod.PayCek)">
        <div class="payment-description">
          <div class="check-box">
            <span class="material-icons">
              {{
                buyer.paymentMethod === PaymentMethod.PayCek
                  ? 'check_circle'
                  : 'radio_button_unchecked'
              }}
            </span>
          </div>
          <div class="payment-text">
            <h3 class="payment-type">PAYCEK</h3>
            <p class="payment-about">{{ $t('cryptoPayment') }}</p>
          </div>
        </div>
        <div class="payment-logo">
          <img src="/assets/paycek-logo.svg" alt="Paycek-logo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PaymentMethod } from '@/types'
export default {
  name: 'store-payment-methods',
  props: {
    buyer: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      PaymentMethod,
    }
  },
  methods: {
    handlePaymentMethodClick(selectedMethod) {
      return (this.buyer.paymentMethod = selectedMethod)
    },
  },
}
</script>

<style scoped>
.component-title {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Rubik;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 550;
  line-height: 120%; /* 28.8px */
  letter-spacing: -0.72px;
  margin-bottom: 8px;
}
.about-next-step {
  color: #333;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 40px;
}

.payment-methods {
  display: flex;
  flex-direction: column;
}
.payment-method {
  display: flex;
  padding: 16px 24px 16px 16px;
  justify-content: space-between;
  gap: 16px;
  border-top: 2px solid #333;
  background: #fff;
  cursor: pointer;
}

.payment-method-zkm {
  max-width: inherit !important;
}
@media screen and (max-width: 455px) {
  .payment-method {
    flex-direction: column !important;
    align-items: flex-start !important;
  }
  .payment-logo {
    align-self: center;
  }
}
.check-box {
  margin-right: 1.125rem;
  margin-top: 5px;
}
.payment-description {
  display: flex;
}
.payment-logo {
  margin-right: 1.5rem;
}
.payment-text {
  padding-right: 0.25rem;
}
.payment-type {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Rubik;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 550;
  line-height: 120%; /* 24px */
  letter-spacing: -0.6px;
}
.payment-about {
  color: #333;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Rubik;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 19.2px */
  letter-spacing: 0.24px;
}
</style>
